import produce from "immer"
import { CcRequirementStatus } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcRequirementStatus: CcRequirementStatus = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    description: "",
    creator: null,
    default: false,
    order: 0,
}

const initCcRequirementStatusState: types.CcRequirementStatusState = {
    statusList: {},
    statusIds: [],
    statusEdit: initCcRequirementStatus,

    reloadList: true,
    reloadEdit: true,
}

const ccRequirementStatusReducer = produce((
    draft: types.CcRequirementStatusState = initCcRequirementStatusState,
    action: ActionTypes = null,
): types.CcRequirementStatusState => {
    switch (action.type) {
        case types.CC_REQUIREMENT_STATUS_LIST:
            draft.statusList = action.statusList
            return draft

        case types.CC_REQUIREMENT_STATUS_IDS:
            draft.statusIds = action.statusIds
            return draft

        case types.CC_REQUIREMENT_STATUS_EDIT:
            draft.statusEdit = action.status
            return draft

        case types.CC_REQUIREMENT_STATUS_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_REQUIREMENT_STATUS_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccRequirementStatusReducer
